<template>
  <div>
    <aw-petrol
      v-if="selectedPetrolStation?.id"
      :petrol-stations="petrolStations"
      :selected-petrol-station="selectedPetrolStation"
    />
  </div>
</template>

<script setup lang="ts">
  import { useRoute, useAsyncData, useNuxtApp } from 'nuxt/app';
  import { useStoresAndPetrolsStore } from '~~/common/stores/storesAndPetrolsStore';
  import { computed, defineAsyncComponent, ref } from 'vue';
  import { defineI18nRoute } from '#i18n';
  import { SEO_MODULE_PETROL } from '~~/common/config/SeoConfig';
  import { setErrorNotification } from '~~/common/utils/helper';
  import { useSeoStore } from '~~/common/stores/seo.js';

  const AwPetrol = defineAsyncComponent(() => import('~~/shop/app/components/Page/Petrol/AwPetrol.vue'));
  const route = useRoute();
  const nuxtApp = useNuxtApp();
  const { $logger } = nuxtApp;

  defineOptions({
    name: 'PetrolPage',
  });

  // eslint-disable-next-line no-undef
  definePageMeta({
    layout: 'full-width',
  });

  false && /*#__PURE__*/ defineI18nRoute({
    paths: {
      en: '/petrol/[slug]',
      hu: '/benzinkutak/[slug]',
    },
  });
  const storesAndPetrolsStore = useStoresAndPetrolsStore();
  const seoStore = useSeoStore();

  const petrolStations = computed(() => storesAndPetrolsStore.petrolStations);

  const dataKey = ref(`stores_${route.params.slug}`);
  const { data: selectedPetrolStation } = await useAsyncData(
    dataKey.value,
    async () => await fetchPetrolStations(),
    {
      watch: [dataKey],
      default: () => null,
    },
  );

  async function fetchPetrolStations () {
    try {
      await storesAndPetrolsStore.fetchAuchanPetrolStations();
      const newSelectedPetrolStation = storesAndPetrolsStore.petrolStations.find(petrolStation => route.params.slug === petrolStation.slug);
      await seoStore.fetchSeoData({
        seoModule: SEO_MODULE_PETROL,
        id: newSelectedPetrolStation?.id,
      });
      return newSelectedPetrolStation ?? null;
    } catch (error) {
      $logger.error(error);
      setErrorNotification({
        nuxtApp,
        error,
      });
      return null;
    }
  }
</script>
